import { render, staticRenderFns } from "./ProfileModule.vue?vue&type=template&id=2f58bd8a"
import script from "./ProfileModule.vue?vue&type=script&lang=js"
export * from "./ProfileModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports